<template>
  <div class="title-container">
    <h2 class="title-container__title">
      <span class="prefix" v-if="prefix">{{ prefix }}</span>
      {{ getTranslatedText(title) }}
      <span v-if="titleOption">{{ getTranslatedText(titleOption) }}</span>
    </h2>
    <slot></slot>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language-mixins";

export default {
  mixins: [languageMixins],
  props: {
    prefix: {
      type: String,
    },
    title: {
      type: String,
    },
    titleOption: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/public/scss/common/title/index.scss";

span.prefix {
  color: #ff7700;
}
</style>

